<template>
  <div class="">
    <agency-treasury-edit> </agency-treasury-edit>
  </div>
</template>

<script>
import AgencyTreasuryEdit from "@/components/profile/treasuries/agency/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    AgencyTreasuryEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Forme di pagamento di Agenzia",
        path: "module.PROF.CAGG",
        tab: "AgencyTreasuries",
        level: 3,
      });
      bcs.push({
        text: "Modifica Forme di pagamento di Agnezia",
        path: "treasuries.edit0",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Forme di pagamento di Agenzia",
        path: "module.PROF.CAGG",
        tab: "AgencyTreasuries",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Forme di pagamento di Agenzia",
        path: "treasuries.edit0",
        level: 4,
      });
    }
  },
};
</script>
